import { InternalAxiosRequestConfig } from 'axios';

import KeycloakService from '@/services/keycloak';

export const axiosRequestFulfilledInterceptor = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: InternalAxiosRequestConfig<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): InternalAxiosRequestConfig<any> => {
  const { token } = KeycloakService.keycloakInstance;
  if (token) {
    value.headers.Authorization = `Bearer ${token}`;
  }
  return value;
};
